import { render, staticRenderFns } from "./ReportData.vue?vue&type=template&id=ef53b88a&scoped=true"
import script from "./ReportData.vue?vue&type=script&lang=js"
export * from "./ReportData.vue?vue&type=script&lang=js"
import style0 from "./ReportData.vue?vue&type=style&index=0&id=ef53b88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef53b88a",
  null
  
)

export default component.exports